import { Reducer } from 'redux';
import { IAdvertisementRadio, IAdvertisementRadioActionTypes } from './Types';

const initialAdvertisementRadio: IAdvertisementRadio = {
  result: null,
  isLoading: false,
  error: '',
};

const reducer: Reducer<IAdvertisementRadio> = (
  state = initialAdvertisementRadio,
  action
) => {
  switch (action.type) {
    case IAdvertisementRadioActionTypes.GET_AD_RADIO: {
      return {
        ...state,
        isLoading: true,
        error: '',
        result: null,
      };
    }
    case IAdvertisementRadioActionTypes.GET_AD_RADIO_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        result: null,
      };
    }
    case IAdvertisementRadioActionTypes.GET_AD_RADIO_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        result: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as AdvertisementRadioReducer };
